// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiFeedItemType } from '../models/ApiFeedItemType';
import { HttpFile } from '../http/http';

export class ApiFeedItem {
    'serial_no': number;
    'type': ApiFeedItemType;
    'item': any;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "serial_no",
            "baseName": "serial_no",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "ApiFeedItemType",
            "format": ""
        },
        {
            "name": "item",
            "baseName": "item",
            "type": "any",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiFeedItem.attributeTypeMap;
    }

    public constructor() {
    }
}



